import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import OpenModalButton, {
  OpenModalButtonProps,
} from 'components/OpenModalButton';
import { MessageBundle } from '@xbcb/ui-types';
import { useBundle } from '@amzn/react-arb-tools';

const createImportAdditionalTariffModalContent = (bundle: MessageBundle) => (
  <>
    <PlusOutlined /> {'Import Additional Tariff'}
  </>
);

interface CreateButtonModalProps extends OpenModalButtonProps {
  modalContent?: React.ReactNode | JSX.Element;
}

export const CreateAdditionalTariffModal: React.FC<CreateButtonModalProps> = ({
  modalContent,
  ...props
}: CreateButtonModalProps) => {
  const [bundle] = useBundle('shared');
  const defaultContent = bundle
    ? createImportAdditionalTariffModalContent(bundle)
    : null;
  return (
    <OpenModalButton key={`${props.modalKey}Button`} {...props}>
      {modalContent || defaultContent}
    </OpenModalButton>
  );
};

export default CreateAdditionalTariffModal;
